<template>
  <section class="row">
    <div class="col-12">
      <div class="card shadow">
        <div
          class="card-body px-md-4 py-md-5 rounded-4 py-4 transition-shadow
            box-shadow-green-300 box-shadow-hover-green-300"
        >
          <div class="row">
            <div class="col-1 pe-0">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-10">
              <div class="h5 text-center mb-3">
                Nouvelle entreprise
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <p>
                Vous pouvez ajouter ici une autre entreprise qui sera liée à votre compte.
              </p>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <div class="row">
                <v-company-research />
                <div class="d-flex mt-2 ms-auto my-auto text-blue-700">
                  <router-link
                    v-slot="{ navigate }"
                    to="/client/account/companies/add/new"
                    custom
                  >
                    <v-loader
                      v-if="isValid"
                      :next="(event) => navigateTo(navigate, event)"
                      title="Continuer"
                      icon="arrow-white-right"
                      class="w-100"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';
import { validateCompanyName } from '@/utils/validators';
import CompanyResearch from '../helpers/CompanyResearch.vue';

export default {
  name: 'AccoutAddCompany',
  components: {
    'v-company-research': CompanyResearch,
  },
  mixins: [ui],
  computed: {
    ...mapGetters({
      company: 'companies/company',
    }),
    isValid() {
      if (this.company === null) {
        return false;
      }
      return validateCompanyName(this.company.name);
    },
  },
  methods: {
    hide() {
      this.ui_focusScreen(false);
    },
    setState(state) {
      this.state = state;
    },
    navigateTo(navigate, event) {
      navigate(event);
      return Promise.resolve();
    },
  },
};
</script>
